
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import DashboardSection from '../DashboardContainer/DashboardSection';
import styles from './ProcessExcellenceComp.module.css';
import './ProcessExcellenceComp.css';
import axios from 'axios';
import config from '../../config/config';
import MonthlyTrendChart from './HorizontalBarChart/HorizontalBarChart';
import TowerWiseCountChart from './HorizontalBarChart/TowerwiseBar';
import StatCard from './HorizontalBarChart/Stats';
import Kpis from './HorizontalBarChart/Kpis';
import Cards from './HorizontalBarChart/Cards';
// import TileComp from '../ProcureToPayComp/TileComp/TileComp';
import TileCompProcessExcell from './TileCompProcessExcell';
import TileCompRightSide from './TileCompRightSide';

const { API_BASE_URL } = config;


const initialFilters = location.state || {
  yearData: null,
  monthData: null,
  quarterData: null,
};

const ProcessExcellenceComp = () => {
  const [filters, setFilters] = useState(initialFilters);
  const [hasApplied, setHasApplied] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);

  const [year, setYear] = useState([]);
  const [quarter, setQuarter] = useState();
  const [month, setMonth] = useState();
  const [tower, setTower] = useState([]);
  const [towerHead, setTowerHead] = useState("");
  const [process, setProcess] = useState("");
  const [subProcess, setSubProcess] = useState("");
  const [projectLeader, setProjectLeader] = useState("");
  const [reportingManager, setReportingManager] = useState("");
  const [towerNames, setTowerNames] = useState([]);
  const [towerHeadList, setTowerHeadList] = useState([]);
  const [processNames, setProcessNames] = useState([]);
  const [subprocessname, setSubProcessNames] = useState([]);
  const [projectLeadername, setProjectLeaderNames] = useState([]);
  const [reportingManagername, setReportingManagername] = useState([]);
  const [totalreceived, settotalreceived] = useState();
  const [preapproval, setpreapproval] = useState();
  const [postapproval, setpostapproval] = useState();
  const [approved, setapproved] = useState();
  const [wip, setwip] = useState();
  const [hourSavings, sethourSavings] = useState();
  const [fteSavings, setfteSavings] = useState();
  const [costSavings, setcostSavings] = useState();
  const [lean, setlean] = useState();
  const [trans, settrans] = useState();
  const [towercount, settowercount] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [businessfilter, setBusinessFilter] = useState([]);
  const [businessOptions, setBusinessOptions] = useState([]);
  const [statusfilter, setStatusFilter] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);


  const [towerChartData, setTowerChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [monthtrend, setmonthtrend] = useState([]);
  const [monthtrendData, setmonthtrendData] = useState({
    labels: [],
    datasets: [],
  });
  const [dashboardStats, setDashboardStats] = useState({
    total_received: 0,
    total_pre_approval: 0,
    total_post_approval: 0,
    wip: 0,
    approved: 0,
    hours_savings: 0.0,
    fte_savings: 0.0,
    cost_savings: 0.0,
  });
  const valOrAll = (val, allOptions) => {
    if (!val || (Array.isArray(val) && val.length === 0)) {
      return allOptions.map((opt) => opt.value);
    }
    return Array.isArray(val) ? val.map((v) => v.value) : [val.value];
  };

  const yearOptions = [...new Set(apiData.map(d => d.year))]
    .sort((a, b) => a - b)
    .map(y => ({ value: y, label: y }));


  const quarterOptions = year
    ? [...new Set(apiData.filter(d => d.year === year.value).map(d => d.quarter))]
      .sort((a, b) => a - b)
      .map(q => ({ value: q, label: `Q${q}` }))
    : [];


  const monthOptions = year && quarter?.length
    ? apiData
      .filter(d => d.year === year.value && quarter.map(q => q.value).includes(d.quarter))
      .map(m => ({ value: m.month, label: m.month_label }))
    : [];

  const fetchbusiness = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-business`,
        {},
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );

      // Correct path to array
      const dataArray = Array.isArray(response.data.data?.data) ? response.data.data.data : [];
      console.log("Data array:", dataArray); // should now show your objects

      setBusinessOptions(dataArray);
      setBusinessFilter([]); // start empty
    } catch (error) {
      console.error("Error fetching business names:", error);
    }
  };

  const fetchStatus = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-Status`,
        {},
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );

      const dataArray = Array.isArray(response.data.data?.data) ? response.data.data.data : [];
      console.log("Data array:", dataArray);

      setStatusOptions(dataArray);
      setStatusFilter([]);
    } catch (error) {
      console.error("Error fetching business names:", error);
    }
  };

  const fetchTowerNames = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-towernames`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,

          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      setTowerNames(response.data.data || []);
    } catch (error) {
      console.error("Error fetching tower names:", error);
    }
  };

  const fetchTowerHeadNames = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-towerheadnames`,
        {

          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,
          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );

      setTowerHeadList(response.data.data || []);

    } catch (error) {
      console.error("Error fetching tower head names:", error);
    }
  };

  const fetchProcessNames = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-processnames`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,
          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      setProcessNames(response.data.data || []);
    } catch (error) {
      console.error("Error fetching process names:", error);
    }
  };

  const fetchSubProcessNames = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-subprocess`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,
          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll, // dependency
          process_name: process?.length ? process.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      setSubProcessNames(response.data.data || []);
    } catch (error) {
      console.error("Error fetching sub processes:", error);
    }
  };

  const fetchProcessLeaders = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-processleader`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,
          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll, // dependency
          process_name: process?.length ? process.map(t => t.value) : valOrAll, // dependency
          sub_process_name: subProcess?.length ? subProcess.map(t => t.value) : valOrAll,
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      setProjectLeaderNames(response.data.data || []);
    } catch (error) {
      console.error("Error fetching project leaders:", error);
    }
  };

  const fetchReportingManagers = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-reportingmanager`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,
          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll, // dependency
          process_name: process?.length ? process.map(t => t.value) : valOrAll, // dependency
          sub_process_name: subProcess?.length ? subProcess.map(t => t.value) : valOrAll,
          project_leader: projectLeader?.length ? projectLeader.map(t => t.value) : valOrAll,
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      setReportingManagername(response.data.data || []);
    } catch (error) {
      console.error("Error fetching reporting managers:", error);
    }
  };

  const reloadData = () => {
    fetchDashboardStats();
    fetchleankaizen();
    fetchtransformation();
    fetchTowercount();
    fetchMonthTrend();
  };

  const dependencyMap = [
    {
      deps: ["tower"],
      fetch: fetchTowerHeadNames,
      reset: () => {
        setTowerHead(null); setTowerHeadList([]);
        setProcess(null); setProcessNames([]);
        setSubProcess(null); setSubProcessNames([]);
        setProjectLeader(null); setProjectLeaderNames([]);
        setReportingManager(null); setReportingManager([]);
      },
    },
    {
      deps: ["tower", "towerHead"],
      fetch: fetchProcessNames,
      reset: () => {
        setProcess(null); setProcessNames([]);
        setSubProcess(null); setSubProcessNames([]);
        setProjectLeader(null); setProjectLeaderNames([]);
        setReportingManager(null); setReportingManager([]);
      },
    },
    {
      deps: ["tower", "towerHead", "process"],
      fetch: fetchSubProcessNames,
      reset: () => {
        setSubProcess(null); setSubProcessNames([]);
        setProjectLeader(null); setProjectLeaderNames([]);
        setReportingManager(null); setReportingManager([]);
      },
    },
    {
      deps: ["tower", "towerHead", "process", "subProcess"],
      fetch: fetchProcessLeaders,
      reset: () => {
        setProjectLeader(null); setProjectLeaderNames([]);
        setReportingManager(null); setReportingManager([]);
      },
    },
    {
      deps: ["tower", "towerHead", "process", "subProcess", "projectLeader"],
      fetch: fetchReportingManagers,
      reset: () => {
        setReportingManager(null); setReportingManager([]);
      },
    },
  ];


  useEffect(() => {
    for (const { deps, fetch, reset } of dependencyMap) {
      const allFilled = deps.every((d) => {

        const stateMap = {
          tower,
          towerHead,
          process,
          subProcess,
          projectLeader,
        };
        const val = stateMap[d];
        return val && val.length > 0;
      });

      if (allFilled) {
        fetch();
      } else {
        reset();
      }
    }
  }, [tower, towerHead, process, subProcess, projectLeader]);


  useEffect(() => {
    reloadData();
  }, [

    tower,
    towerHead,
    process,
    subProcess,
    projectLeader,
    reportingManager,
  ]);


  const handleApply = () => {
    setTower([]);
    setTowerHead(null);
    setProcess(null);
    setSubProcess(null);
    setProjectLeader(null);
    setReportingManager(null);
    setTowerNames([]);
    setTowerHeadList([]);
    setProcessNames([]);
    setSubProcessNames([]);
    setProjectLeaderNames([]);
    setReportingManagername([]);
    fetchTowerNames();
    setShowFilters(true);
    setShowDashboard(true);
    fetchleankaizen();
    fetchtransformation();
    fetchTowercount();
    fetchMonthTrend();
    fetchDashboardStats();
  };

  const handleReset = () => {
    setYear(null);
    setQuarter(null);
    setMonth(null);
    setFilters({ yearData: null, quarterData: null, monthData: null });
    setTower([]);
    setTowerHead(null);
    setProcess(null);
    setSubProcess(null);
    setProjectLeader(null);
    setReportingManager(null);
    setTowerNames([]);
    setTowerHeadList([]);
    setProcessNames([]);
    setSubProcessNames([]);
    setProjectLeaderNames([]);
    setReportingManagername([]);
    setBusinessFilter([]);
    fetchbusiness();
    fetchStatus();
    setShowFilters(false);
    setShowDashboard(false);
    fetchFilterOptions();
  };

  const handleYearChange = (selectedYear) => {
    setYear(selectedYear);
    setFilters(prev => ({ ...prev, yearData: selectedYear }));
    setQuarter([]);
    setMonth([]);
    setFilters(prev => ({ ...prev, quarterData: [], monthData: [] }));
  };

  const handleQuarterChange = (selectedQuarters) => {
    setQuarter(selectedQuarters);
    setFilters(prev => ({ ...prev, quarterData: selectedQuarters }));
    setMonth([]);
    setFilters(prev => ({ ...prev, monthData: [] }));
  };

  const handleMonthChange = (selectedMonths) => {
    setMonth(selectedMonths);
    setFilters(prev => ({ ...prev, monthData: selectedMonths || [] }));
  };


  const fetchFilterOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/ProcessEx-filters`, {
        headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' },
      });
      setApiData(response.data);
    } catch (error) {
      console.error("Error fetching filter options:", error);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
    fetchbusiness();
    fetchStatus();
  }, []);


  const fetchleankaizen = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-LeanKaizen`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,
          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll,
          process_name: process?.length ? process.map(t => t.value) : valOrAll,
          sub_process_name: subProcess?.length ? subProcess.map(t => t.value) : valOrAll,
          project_leader: projectLeader?.length ? projectLeader.map(t => t.value) : valOrAll,
          reporting_manager: reportingManager?.length ? reportingManager.map(t => t.value) : valOrAll,
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length
            ? businessfilter.map(t => t.value)
            : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      setlean(response.data?.data?.lean_kaizen ?? 0);
    } catch (error) {
      console.error("Error fetching tower names:", error);
    }
  };

  const fetchtransformation = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-transformation`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,
          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll,
          process_name: process?.length ? process.map(t => t.value) : valOrAll,
          sub_process_name: subProcess?.length ? subProcess.map(t => t.value) : valOrAll,
          project_leader: projectLeader?.length ? projectLeader.map(t => t.value) : valOrAll,
          reporting_manager: reportingManager?.length ? reportingManager.map(t => t.value) : valOrAll,
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length
            ? businessfilter.map(t => t.value)
            : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      settrans(response.data?.data?.transformation ?? 0);
    } catch (error) {
      console.error("Error fetching tower names:", error);
    }
  };

  const fetchDashboardStats = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-dashboardstats`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,

          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll,
          process_name: process?.length ? process.map(p => p.value) : valOrAll,
          sub_process_name: subProcess?.length ? subProcess.map(sp => sp.value) : valOrAll,
          project_leader: projectLeader?.length ? projectLeader.map(pl => pl.value) : valOrAll,
          reporting_manager: reportingManager?.length ? reportingManager.map(rm => rm.value) : valOrAll,
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length
            ? businessfilter.map(t => t.value)
            : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );

      const data = response.data?.data?.data ?? {};
      setDashboardStats({
        total_received: data.total_received ?? 0,
        total_pre_approval: data.total_pre_approval ?? 0,
        total_post_approval: data.total_post_approval ?? 0,
        wip: data.wip ?? 0,
        approved: data.approved ?? 0,
        hours_savings: data.hours_savings ?? 0.0,
        fte_savings: data.fte_savings ?? 0.0,
        cost_savings: data.cost_savings ?? 0.0,
      });
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };

  const fetchTowercount = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-towercount`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,
          selectedQuarter: quarter?.length ? quarter.map(t => t.value) : valOrAll,
          selectedMonth: month?.length ? month.map(t => t.value) : valOrAll, // dependency: valOrAll,
          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll,
          process_name: process?.length ? process.map(t => t.value) : valOrAll,
          sub_process_name: subProcess?.length ? subProcess.map(t => t.value) : valOrAll,
          project_leader: projectLeader?.length ? projectLeader.map(t => t.value) : valOrAll,
          reporting_manager: reportingManager?.length ? reportingManager.map(t => t.value) : valOrAll,
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll,
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll, // dependency
          business_options: businessfilter?.length
            ? businessfilter.map(t => t.value)
            : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );

      const apiData = response.data.data.data;
      settowercount(apiData);
      const labels = apiData.map(item => item.tower_name);
      const counts = apiData.map(item => item.tower_count);
      setTowerChartData({
        labels,
        datasets: [
          {
            label: "Tower Count",
            data: counts,
            // backgroundColor: "#2386ea",
            backgroundColor: linearGradient("#f5a722", "#f0c961"),

          },
        ],
      });
    } catch (error) {
      console.error("Error fetching tower count:", error);
    }
  };

  function linearGradient(startColor, endColor) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, startColor);
    gradient.addColorStop(1, endColor);

    return gradient;
  }


  const fetchMonthTrend = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/ProcessEx-monthtrend`,
        {
          selectedYear: Array.isArray(year)
            ? year.map(t => t.value)
            : year
              ? [year.value]
              : valOrAll,

          tower_name: tower?.length ? tower.map(t => t.value) : valOrAll,
          tower_head_name: towerHead?.length ? towerHead.map(t => t.value) : valOrAll,
          process_name: process?.length ? process.map(t => t.value) : valOrAll,
          sub_process_name: subProcess?.length ? subProcess.map(t => t.value) : valOrAll,
          project_leader: projectLeader?.length ? projectLeader.map(t => t.value) : valOrAll,
          reporting_manager: reportingManager?.length ? reportingManager.map(t => t.value) : valOrAll,
          business_options: businessfilter?.length ? businessfilter.map(t => t.value) : valOrAll, // dependency
          status_options: statusfilter?.length ? statusfilter.map(t => t.value) : valOrAll,
          business_options: businessfilter?.length
            ? businessfilter.map(t => t.value)
            : valOrAll,
        },
        { headers: { Authorization: "Basic YWRtaW4xOjEyMw==" } }
      );
      const apiDatanew = response.data.data.data;
      setmonthtrend(apiDatanew);
      const monthNames = [
        "",
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const labels = apiDatanew.map(item => monthNames[item.month]);
      const counts = apiDatanew.map(item => item.count);
      setmonthtrendData({
        labels,
        datasets: [
          {
            label: "Months",
            data: counts,
            backgroundColor: linearGradient("#0359e4ff", "#cedef3ff"),
          }
        ]

      });
    } catch (error) {
      console.error("Error fetching tower count:", error);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  useEffect(() => {

    if (hasApplied) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const customStylesMultiSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const amberGradient = 'linear-gradient(135deg, #FBBF24 0%, #F97316 100%)';
  const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
  const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
  const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
  const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
  const emeraldGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';

  const formatIndianNumber = (num) => {
    if (num === null || num === undefined) return '0';
    const numStr = num.toString();
    const [integerPart, decimalPart] = numStr.split('.');
    const lastThree = integerPart.substring(integerPart.length - 3);
    const otherNumbers = integerPart.substring(0, integerPart.length - 3);

    let formatted = otherNumbers ?
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree :
      lastThree;
    return decimalPart ? `${formatted}.${decimalPart}` : formatted;
  };

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Business</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                isMulti
                closeMenuOnSelect={false}
                options={businessOptions}
                value={businessfilter}
                onChange={(selected) => setBusinessFilter(selected || [])}
                placeholder="Select Business"
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Status</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                isMulti
                closeMenuOnSelect={false}
                options={statusOptions}
                value={statusfilter}
                // onChange={(selected) => setBusinessFilter(selected || [])}
                onChange={(selected) => setStatusFilter(selected || [])}
                placeholder="Select Business"
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                isMulti={true}
                closeMenuOnSelect={false}
                value={quarter}
                onChange={handleQuarterChange}
                options={quarterOptions}
                isSearchable={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                isMulti={true}
                closeMenuOnSelect={false}
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>

          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      {showFilters && (
        <div className={styles.filter_panel_container}>
          <div className={`${styles.filter_panel_row} d-flex flex-wrap mt-3`}>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Tower Name</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  value={tower}
                  onChange={setTower}
                  options={towerNames.map((name) => ({
                    value: name,
                    label: name || "(blank)",
                  }))}
                  isSearchable={false}
                  styles={customStylesMultiSelect}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Tower Head Name</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  value={towerHead}
                  onChange={setTowerHead}
                  options={towerHeadList.map((name) => ({
                    value: name,
                    label: name,
                  }))}
                  isSearchable={false}
                  styles={customStylesMultiSelect}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Process Name</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  value={process}
                  onChange={setProcess}
                  options={processNames.map((name) => ({
                    value: name,
                    label: name,
                  }))}
                  isSearchable={false}
                  styles={customStylesMultiSelect}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Sub Process Name</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  value={subProcess}
                  onChange={setSubProcess}
                  options={subprocessname.map((name) => ({
                    value: name,
                    label: name,
                  }))}
                  isSearchable={false}
                  styles={customStylesMultiSelect}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Project Leader</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  value={projectLeader}
                  onChange={setProjectLeader}
                  options={projectLeadername.map((name) => ({
                    value: name,
                    label: name,
                  }))}
                  isSearchable={false}
                  styles={customStylesMultiSelect}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Reporting Manager</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  value={reportingManager}
                  onChange={setReportingManager}
                  options={reportingManagername.map((name) => ({
                    value: name,
                    label: name,
                  }))}
                  isSearchable={false}
                  styles={customStylesMultiSelect}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {showDashboard && (
        <div className="container-fluid">

          <div className="row">
            {/* 1st Col */}
            <div className="col-md-2  d-flex flex-column gap-2">
              {/* <Kpis title="Total Received" value={dashboardStats.total_received} /> */}
              <TileCompProcessExcell
                title="Total Received"
                number={dashboardStats.total_received}
                gradient={amberGradient}
                popupContent="This metric is the Manual CSV Data"
              />
              {/* <Kpis title="Pending" value={dashboardStats.total_pre_approval} /> */}
              <TileCompProcessExcell
                title="Pending"
                number={dashboardStats.total_pre_approval}
                gradient={paidOnTimeGradient}
                popupContent="This metric is the Manual CSV Data"
              />
              {/* <Kpis title="Awaiting Approval" value={dashboardStats?.total_post_approval} /> */}
              <TileCompProcessExcell
                title="Awaiting Approval"
                number={dashboardStats?.total_post_approval}
                gradient={indigoGradient}
                popupContent="This metric is the Manual CSV Data"
              />
              {/* <Kpis title="Total WIP" value={dashboardStats?.wip} /> */}
              <TileCompProcessExcell
                title="Total WIP"
                number={dashboardStats?.wip}
                gradient={blueGradient}
                popupContent="This metric is the Manual CSV Data"
              />
              {/* <Kpis title="Total Closed" value={dashboardStats?.approved} /> */}
              <TileCompProcessExcell
                title="Total Closed"
                number={dashboardStats?.approved}
                gradient={purpleGradient}
                popupContent="This metric is the Manual CSV Data"
              />
            </div>
            {/* 2nd Col */}
            <div className="col-md-8 d-flex flex-column">

              <div className="row mb-2" >
                <div className="col-md-6">
                  <DashboardSection title='Monthly Trend' disableDetailView={true} infoIcondata={"Manual CSV Data"}>
                    <MonthlyTrendChart data={monthtrendData} />
                  </DashboardSection>
                </div>
                <div className="col-md-6">
                  <DashboardSection title='TowerWise Count' disableDetailView={true} infoIcondata={"Manual CSV Data"}>
                    <TowerWiseCountChart data={towerChartData} />
                  </DashboardSection>
                </div>
              </div>

              <div className="row " style={{ height: '250px' }}>
                <div className="col-md-6 mt-2" >
                  <DashboardSection title='' disableDetailView={true} infoIcondata={"Manual CSV Data"}>
                    <StatCard number={lean} label="Lean Kaizen" />
                  </DashboardSection>
                </div>
                <div className="col-md-6 mt-2">
                  <DashboardSection title='' disableDetailView={true} infoIcondata={"Manual CSV Data"}>
                    <StatCard number={trans} label="Transformation" />
                  </DashboardSection>
                </div>
              </div>

            </div>
            {/* 3rd Col */}
            <div className="col-md-2 d-flex justify-content-center flex-column gap-4 ">
              {/* <Cards title="Hours Savings" value={dashboardStats.hours_savings} /> */}
              <TileCompRightSide
                title="Hours Savings"
                number={dashboardStats.hours_savings}
                gradient={amberGradient}
                popupContent="This metric is the Manual CSV Data"
              />
              {/* <Cards title="FTE Savings" value={dashboardStats.fte_savings} /> */}
              <TileCompRightSide
                title="FTE Savings"
                number={dashboardStats.fte_savings}
                gradient={paidOnTimeGradient}
                popupContent="This metric is the Manual CSV Data"
              />
              {/* <Cards title="Cost Savings" value={dashboardStats.cost_savings} /> */}
              <TileCompRightSide
                title="&#8377; Cost Savings"
                // number={dashboardStats.cost_savings}
                number={formatIndianNumber(dashboardStats.cost_savings)}
                gradient={blueGradient}
                popupContent="This metric is the Manual CSV Data"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProcessExcellenceComp;
